// extracted by mini-css-extract-plugin
export default {"root__mobile":"ThreeByOneHScrollWidget_root__mobile__CoYY5"};